<template>
  <div class="flex items-center">
    <input
      :id="radioButton.item?.key"
      type="radio"
      :checked="props.isSelected"
      :disabled="props.disabled"
      @change="$emit('change', radioButton.item)"
      class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600 disabled:text-gray-400 disabled:bg-gray-300 disabled:hover:bg-gray-300 disabled:cursor-not-allowed"
    />
    <label
      :for="radioButton.item?.key"
      class="ml-3 block text-sm text-gray-900"
      @click="clickOnLabel"
      >{{ radioButton?.label }}</label
    >
  </div>
</template>
<script setup lang="ts">
import { defineProps, defineEmits, ref } from "vue";
import { DynamicProperty, RadioItem } from "@/models/dtos";
const emit = defineEmits(["change"]);
const props = defineProps({
  model: {
    type: DynamicProperty,
    required: true,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  isSelected: {
    type: Boolean,
    required: false,
    default: false,
  },
});

let radioButton = ref(new RadioItem(props.model, props.model.label));
const clickOnLabel = () => {
  if (props.disabled) return;

  emit("change", radioButton.value.item);
};
</script>
